import { Component } from '@angular/core';
import { Globals } from './services/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { BroadcastService } from './services/broadcast.service';
import { InspirationRoomService } from './canvas/services/inspiration-rooms/inspiration-room.service';
import { Appointment, AuthPayload, Option } from './engine/models/models';
import { BehaviorSubject } from 'rxjs';
import { OptionSelectorService } from './canvas/services/option-selector.service';
import { environment } from '../environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { RequestAssistanceComponent } from './components/request-assistance/request-assistance.component';
import { AuthenticationService } from './services/authenticate.service';
import { UserIdleService } from 'angular-user-idle';
import { SessionTimeoutSnackComponent } from './components/session-timeout-snack/session-timeout-snack.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  userEmail: string;
  appointment: Appointment;
  userData = new BehaviorSubject<AuthPayload>(new AuthPayload());

  constructor(private authenticationService: AuthenticationService,
    public globals: Globals,
    private userIdle: UserIdleService,
    private router: Router,
    private broadcastService: BroadcastService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog) {
    //window.onunload = function (e) {
    //  localStorage.clear();
    //  sessionStorage.clear();
    //};

    const session = JSON.parse(localStorage.getItem('appointment'));

    if (session) {
      this.userEmail = session.userEmail;
      this.broadcastService.subscribe("EVENT", (userName) => {
        this.userEmail = userName;
      });
    }
    else {
      this.userEmail = "gjohnston@mannacor.com";
    }
  }

  ngOnInit() {
    if (this.isLogIn && !this.isAdminLogin && !this.globals.isImpersonating) {
      //Start watching for user inactivity.
      this.userIdle.startWatching();

      // Start watching when user idle is starting.
      this.userIdle.onTimerStart().subscribe(count => { if (count == 1) { this.idleWarning() } });

      // Start watch when time is up.
      this.userIdle.onTimeout().subscribe(() => this.timeOut());

      this.userIdle.ping$.subscribe(() => this.globals.UpdateClientSession());
    }
  }

  restart() {
    this.userIdle.resetTimer();
  }

  timeOut() {
    this.snackBar.dismiss();
    this.logout()
    this.userIdle.stopTimer();
    this.userIdle.stopWatching();
  }

  idleWarning() {
    this.snackBar.openFromComponent(SessionTimeoutSnackComponent, {
      panelClass: 'max-width-60vw',
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 60 * 1000,
    });
  }

  openRequestAssistance() {
    const dialogRef = this.dialog.open(RequestAssistanceComponent, {
      data: this.globals.getRequestAssistanceDetails(),
      width: '60%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      return;
    });
  }

  get isLogIn(): boolean {
    return JSON.parse(localStorage.getItem('appointment')) ? true : false;
  }

  get isAdminLogin(): boolean {
    return (localStorage.getItem("userType") && JSON.parse(localStorage.getItem("userType")).isAdmin) ? true : false;
  }

  get showHelpIcon(): boolean {
    return this.isLogIn && !this.isAdminLogin && this.router.url === "/selections"
  }

  onActivate(event: any): void {
    this.snackBar.dismiss();
  }

  logout() {
    let userEmail = localStorage.getItem("userEmail");
    sessionStorage.clear();
    localStorage.clear();
    localStorage.removeItem('authToken');
    localStorage.setItem("userEmail", userEmail);
    this.router.navigate(['/login']);
    this.userData.next(new AuthPayload());
  }
}
